import script from "./Admin.vue?vue&type=script&setup=true&lang=js"
export * from "./Admin.vue?vue&type=script&setup=true&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=6a0a3a81&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a0a3a81"]])

export default __exports__